import { Card, CardContent } from "~/components/ui/card";

/**
 * One headline number, as a tile, shared by the admin dashboards' KPI rows.
 *
 * Values use proportional figures: at this size `tabular-nums` gives every digit
 * a `0`'s width and makes a number like 121 look loose.
 */
export const Stat = ({
  label,
  value,
  unit,
  detail,
  children,
}: {
  label: string;
  /** A node so a tile can stand a placeholder where its figure will go. */
  value: React.ReactNode;
  /** Rendered smaller than `value`, for a unit or a denominator. */
  unit?: string;
  detail?: React.ReactNode;
  /** Sits on the value's baseline, for a delta or a badge. */
  children?: React.ReactNode;
}) => (
  <Card className="gap-0 py-4 shadow-none">
    <CardContent className="px-4">
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <div className="mt-1 flex flex-wrap items-baseline gap-x-2">
        <span className="text-3xl font-semibold text-foreground">
          {value}
          {unit && <span className="text-lg font-normal text-muted-foreground">{unit}</span>}
        </span>
        {children}
      </div>
      {detail && <p className="mt-1 text-xs text-muted-foreground">{detail}</p>}
    </CardContent>
  </Card>
);
